var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" Copyright @ 2012-2025 triplefireman 版权所有    "),_c('a',{attrs:{"href":"http://triplefireman.com","target":"_blank"}},[_vm._v("triplefireman.com")])])
}]

export { render, staticRenderFns }